import $ from 'jquery';
import PageCache from 'lib/page-cache';
import lscs from 'lib/services/lscs';
import tdaConfig from 'lib/util/tda.config';

function __transformCompareDcr(data) {
  var seriesHash = {};
  $(data).find('Vehicle').each(function () {
    var seriesString = $(this).find('series').text();
    var yearString = $(this).find('toyotaVehicleName').text().substring(0, 4);
    var firstCompareURLArray = $(this).find('conquestPath:first').text().split('/');
    if (firstCompareURLArray[1] === 'sites') {
      firstCompareURLArray.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
      firstCompareURLArray.unshift('/' + tdaConfig.site.context_url);
    }
    var firstCompareURL = firstCompareURLArray.join('/'); // create URL from array
    // UPDATE HASH FOR year/series with first compare url.
    var hashKey = yearString + '-' + seriesString;
    seriesHash[hashKey] = firstCompareURL;
  });
  return seriesHash;
}
/*
  val of compareSource is 'local' or 'global', set in navigation.vehicles
  that's the only spot we have to read this vehicleAssociation configuration
  it comes from the nav editor, on the vehicles link, TDA can change to:
  off: 'global', local: 'local', default: 'global'
  which means this is all horse poo anyway, because the nav editor shouldn't really be the spot
  for a TDA to configure which vehicle association to use.
  This is NOT to be confused with the DCR found on the /compare/ page
  The vehicle association selection on that page is specific for the /compare/ page only.
  This means the links on our compare CTAs (or whomever consumes this loader) could be inaccurate
  It's all good... no one knows how this globale/local 'feature' works anyway
*/
var compareSource = PageCache.get('series.compare.association.location');
var compareCacheId = 'series.compare.urlMap';

var compareConfig = {};
if (compareSource === 'local') {
  compareConfig.path = 'templatedata/BAT/VehicleAssociation/data/LocalVehicleAssociation.xml';
  compareConfig.tda = tdaConfig.tda.code;
} else {
  compareConfig.path = 'templatedata/BAT/VehicleAssociation/data/VehicleAssociation.xml';
  compareConfig.tda = 'WWW';
}

if (!PageCache.has(compareCacheId) && !PageCache.isPending(compareCacheId)) {
  PageCache.maybeSet(
    compareCacheId,
    lscs.dcr()
      .fetch(compareConfig)
      .then(__transformCompareDcr)
  );
}
